import styled from 'styled-components';
import { CredusButton, CredusText, CredusWrapper } from 'ui';
import { GraphIcon, Calendar, Time } from '../../../assets/images/svgs';
import { useNavigate } from 'react-router';
import { IOverviewTest } from '../overview-models/overview.Interface';
import moment from 'moment';

const AnalyticsCard = ({ test }: IOverviewTest) => {
  const navigate = useNavigate();
  const onSelectCard = () => {
    if(test.categoryId) sessionStorage.setItem("categoryId", `${test.categoryId}`);
    if(test.periodId) sessionStorage.setItem("periodId", `${test.periodId}`);
    if(test.subjectId) sessionStorage.setItem("subjectId", `${test.subjectId}`);
    if(test.testId) sessionStorage.setItem("testId", `${test.testId}`);
    navigate('/report', { state: { test } });
  };
  return (
    <AnalyticsWrap>
      <CredusWrapper display="flex" justify="space-between">
        <CredusWrapper>
          <CredusText size="md" weight="medium">
            {test.subjectName} <SpacerDIv /> <DivSpan>{test.testCode} </DivSpan>{' '}
          </CredusText>
          <CredusText
            mt="1rem"
            size="sm"
            weight="medium"
            color="rgba(43, 45, 66, 0.5)"
          >
            {test.description || 'No Description'}
          </CredusText>
          <CredusWrapper mt="1rem" display="flex" align="center" gap="1.25rem">
            <CredusWrapper display="flex" align="center">
              <Calendar />
              <CredusText color="rgba(24, 24, 25, 0.71)" size="sm" ml="0.8rem">
                {/* {test?.testDate ? moment(test?.testDate).format("MMM Do YY") : 'N/A'} */}
                {test?.testDate
                  ? moment(test?.testDate, 'DD/MM/YYYY').format('MMM Do YYYY')
                  : 'N/A'}
              </CredusText>
            </CredusWrapper>
            <CredusWrapper display="flex" align="center">
              <Time />
              <CredusText color="rgba(24, 24, 25, 0.71)" size="sm" ml="0.8rem">
                {/* {test.testTime ? moment(test?.testTime).format('LT'): "N/A"} GMT Nigeria */}
                {test.testTime ? test?.testTime : 'N/A'} GMT Nigeria
              </CredusText>
            </CredusWrapper>
          </CredusWrapper>
        </CredusWrapper>
        <CredusButton onClick={onSelectCard}>
          View Report
          <GraphIcon className="graph-icon" />
        </CredusButton>
      </CredusWrapper>
    </AnalyticsWrap>
  );
};

export default AnalyticsCard;

const AnalyticsWrap = styled.div`
  margin-bottom: 0.625rem;
  width: 98%;
  background: #ffffff;
  border: 1px solid rgba(224, 222, 247, 0.5);
  border-radius: 8px;
  padding: 1.25rem 2.125rem;

  .graph-icon {
    margin-left: 0.875rem;
  }
  button {
    align-self: center;
  }

  &:hover {
    box-shadow: 0px 4px 9px rgba(0, 0, 0, 0.11);
  }
`;
const DivSpan = styled.span`
  color: rgba(43, 45, 66, 0.59);
`;
const SpacerDIv = styled.span`
  position: relative;
  top: -0.06em;
  display: inline-block;
  margin: 0 8px;
  vertical-align: middle;
  margin-right: 1.2rem;
  margin-left: 1.9rem;
  height: 18px;
  border: 1px solid #e0def7;
  display: inline-block;
`;
